module.exports = __webpack_public_path__ + "img/1563116127.aad520a1.jpg";